<script>
export default {
    name: "SearchForm",
    data() {
        return {
            form: {},
            show: true,
        };
    },
    props: {
        fields: Array,
        /**
         * 筛选后，重置当前页到第一页
         */
        resetCurrentPage: {
            type: Boolean,
            default: true,
        },
    },
    created() {
        this.initFormShow();
    },
    methods: {
        onSubmit() {
            const query = { ...this.$route.query };
            if (this.resetCurrentPage) {
                delete query.page;
            }

            // 构建查询对象, 空值的不放入, 保留非搜索表单的 query 字段
            this.fields.forEach((i) => {
                const key = i.field;
                let val = this.form[key];
                if (typeof val === "string") {
                    val = val.trim();
                }

                if (val === "" || val === undefined) {
                    delete query[key];
                } else {
                    query[key] = val;
                    if (key === "time_between") {
                        // 此处需注意仅仅为时间选择器
                        // debugger
                        // console.log(val.toLocaleDateString())
                        // console.log(val)
                        if (val == null) {
                            query[key] = val;
                        } else {
                            query[key] = [val[0], val[1]];
                        }
                    }
                }
            });
            this.$router.push({
                path: this.$route.path,
                query,
            });
        },
        dateFormat(d) {
            const resDate =
                d.getFullYear() +
                "-" +
                this.p(d.getMonth() + 1) +
                "-" +
                this.p(d.getDate());
            const resTime =
                this.p(d.getHours()) +
                ":" +
                this.p(d.getMinutes()) +
                ":" +
                this.p(d.getSeconds());
            return resDate + resTime;
        },
        p(s) {
            return s < 10 ? "0" + s : s;
        },
        onReset() {
            this.form = {};
            this.onSubmit();
        },
        initFormShow() {
            this.fields.some((i) => {
                if (this.$route.query[i.field]) {
                    this.show = true;
                    return true;
                }
            });
        },
        setFormValueFromQuery() {
            const query = this.$route.query;
            this.fields.forEach((i) => {
                const key = i.field;
                const val = query[key];
                this.$set(this.form, key, val);
            });
        },
        toggleShow() {
            this.show = !this.show;
        },
        getOffsetHeight() {
            var o = document.getElementById("div-searchForm");
            var w = o.clientWidth || o.offsetWidth;
            this.formHeight = w;
        },
    },
    watch: {
        $route: {
            handler() {
                this.setFormValueFromQuery();
            },
            immediate: true,
        },
    },

    render(h) {
        return (
            <el-collapse-transition>
                <div v-show={this.show}>
                    <el-form
                        inline
                        vOn:keydown_enter_native_prevent={this.onSubmit}
                    >
                        {this.fields.map((item) => {
                            let c;
                            switch (item.type) {
                                case "el-select":
                                    c = (
                                        <el-select
                                            style="width:150px;"
                                            v-model={this.form[item.field]}
                                            placeholder={item.label}
                                            filterable
                                            clearable
                                        >
                                            {item.options.map((i) => {
                                                // const valueField = item.valueField || 'id'
                                                // const labelField = item.labelField || 'name'
                                                return (
                                                    <el-option
                                                        key={i.value || i.id}
                                                        label={
                                                            i.label || i.name
                                                        }
                                                        value={String(
                                                            i.value || i.id
                                                        )}
                                                    />
                                                );
                                            })}
                                        </el-select>
                                    );
                                    break;
                                case "time-between":
                                    c = (
                                        <el-date-picker
                                            v-model={this.form[item.field]}
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd HH:mm:ss"
                                            start-placeholder={item.label1}
                                            end-placeholder={item.label2}
                                        ></el-date-picker>
                                    );
                                    break;
                                case "super-input":
                                    c = (
                                        <el-input
                                            v-model={this.form[item.field]}
                                            placeholder={item.label}
                                            clearable
                                        />
                                    );
                                    break;
                                default: // 默认是 input
                                    c = (
                                        <el-input
                                            v-model={this.form[item.field]}
                                            placeholder={item.label}
                                            clearable
                                        />
                                    );
                            }

                            return (
                                <el-form-item key={item.field}>
                                    {c}
                                </el-form-item>
                            );
                        })}

                        <el-form-item class="actions">
                            <el-button type="primary" vOn:click={this.onSubmit}>
                                查询
                            </el-button>
                            <el-button vOn:click={this.onReset}>重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </el-collapse-transition>
        );
    },
};
</script>

<style scoped lang="scss">
.search-toggle ::v-deep {
    border: none;
    margin-top: -20px;

    .el-collapse-item__header {
        color: #409eff;
        font-size: 16px;
        border: none;
    }

    .el-collapse-item__arrow {
        display: none;
    }
}

.actions {
    display: inline-block;
    margin-bottom: 10;
}
</style>
